import React, { useState } from "react";
import { Info } from "lucide-react";

const TOOLTIP_TEXT =
  "This is a shared test number. Many users use it, so there is a maximum concurrent user limit.";

export default function TestNumberBadge({ className = "" }) {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <span className="text-[10px] font-medium px-2 py-0.5 rounded-md bg-amber-100 text-amber-800 border border-amber-200">
        Test number
      </span>
      <span className="relative">
        <button
          type="button"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          onFocus={() => setShowTooltip(true)}
          onBlur={() => setShowTooltip(false)}
          className="inline-flex items-center justify-center w-4 h-4 rounded-full text-amber-600 hover:text-amber-800 hover:bg-amber-100 focus:outline-none focus:ring-2 focus:ring-amber-400"
          aria-label="Test number info"
        >
          <Info className="w-3.5 h-3.5" />
        </button>
        {showTooltip && (
          <div
            role="tooltip"
            className="absolute z-50 bottom-full left-0 mb-1 px-3 py-2 text-xs font-normal text-white bg-slate-800 rounded-lg shadow-lg max-w-[240px]"
          >
            {TOOLTIP_TEXT}
          </div>
        )}
      </span>
    </span>
  );
}
